import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Moment from "moment";
import DatePicker from 'components/Inputs/DatePicker';
import SectionTitle from "components/Presentation/SectionTitle";
import UserAssessments from "./Partials/UserAssessments";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { Spinner } from "UI";
import { Button, translate } from "@haldor/ui";
import "./Progress.scss";
var SectionProgress = /*#__PURE__*/function (_Component) {
  function SectionProgress(props) {
    var _props$match$params, _props$match$params2, _props$match$params3, _props$match$params4;
    var _this;
    _classCallCheck(this, SectionProgress);
    _this = _callSuper(this, SectionProgress, [props]);
    _defineProperty(_this, "onDateChange", function (_ref) {
      var start = _ref.start,
        end = _ref.end;
      _this.setState({
        start: start,
        end: end
      });
    });
    _defineProperty(_this, "updateDates", function () {
      var _this$state = _this.state,
        start = _this$state.start,
        end = _this$state.end;
      _this.setState({
        currentStart: start,
        currentEnd: end
      });
    });
    _this.state = {
      start: (_props$match$params = props.match.params) !== null && _props$match$params !== void 0 && _props$match$params.start ? props.match.params.start : Moment().subtract(6, 'months').format("YYYY-MM-DD"),
      end: (_props$match$params2 = props.match.params) !== null && _props$match$params2 !== void 0 && _props$match$params2.end ? props.match.params.end : Moment().format("YYYY-MM-DD"),
      currentStart: (_props$match$params3 = props.match.params) !== null && _props$match$params3 !== void 0 && _props$match$params3.end ? props.match.params.end : Moment().subtract(6, 'months').format("YYYY-MM-DD"),
      currentEnd: (_props$match$params4 = props.match.params) !== null && _props$match$params4 !== void 0 && _props$match$params4.start ? props.match.params.start : Moment().format("YYYY-MM-DD")
    };
    return _this;
  }
  _inherits(SectionProgress, _Component);
  return _createClass(SectionProgress, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        translate = _this$props.translate,
        activeStudent = _this$props.activeStudent;
      var groupId = null;
      if (this.props.match.params == null) {
        groupId = this.props.groupId;
      } else {
        groupId = this.props.match.params.groupId;
      }
      if (this.props.activeSection == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "progress"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "progress"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, translate("Assessments")))), /*#__PURE__*/React.createElement(Box, {
        sx: {
          mb: 2
        }
      }, /*#__PURE__*/React.createElement(Stack, {
        direction: {
          xs: 'column',
          sm: 'row'
        },
        spacing: 2,
        sx: {
          mb: 2
        }
      }, /*#__PURE__*/React.createElement(Box, {
        sx: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Box, {
        component: "label",
        sx: {
          display: 'block',
          mb: 1,
          fontWeight: 500
        }
      }, "Start date"), /*#__PURE__*/React.createElement(DatePicker, {
        value: Moment(this.state.start),
        onChange: function onChange(d) {
          return _this2.onDateChange({
            start: d,
            end: _this2.state.end
          });
        },
        fullWidth: true
      })), /*#__PURE__*/React.createElement(Box, {
        sx: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Box, {
        component: "label",
        sx: {
          display: 'block',
          mb: 1,
          fontWeight: 500
        }
      }, "End date"), /*#__PURE__*/React.createElement(DatePicker, {
        value: Moment(this.state.end),
        onChange: function onChange(d) {
          return _this2.onDateChange({
            start: _this2.state.start,
            end: d
          });
        },
        minDate: Moment(this.state.start),
        fullWidth: true
      }))), /*#__PURE__*/React.createElement(Box, {
        sx: {
          mt: 2
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.updateDates
      }, translate("Update")))), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider",
        style: {
          marginBottom: '3rem'
        }
      }), /*#__PURE__*/React.createElement(UserAssessments, {
        studentId: activeStudent.id,
        sectionId: groupId,
        start: this.state.currentStart,
        end: this.state.currentEnd
      }));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeSection: state.groups.activeGroup,
    studentOverview: state.groups.studentOverview,
    matrixAssessments: state.groups.matrixAssessments,
    activeStudent: state.User.activeStudent,
    studentAssessments: state.groups.studentAssessments,
    translate: translate(state.Languages.translations)
  };
}
export default withRouter(connect(mapStateToProps)(SectionProgress));